import api from '../lib/axios';
export async function getArticles(params) {
    const { data } = await api.get('/api/admin/articles', { params });
    return data;
}
export async function getArticle(id) {
    const { data } = await api.get(`/api/admin/articles/${id}`);
    return data.data;
}
export async function createArticle(body) {
    const { data } = await api.post('/api/admin/articles', body);
    return data.data;
}
export async function updateArticle(id, body) {
    const { data } = await api.patch(`/api/admin/articles/${id}`, body);
    return data.data;
}
export async function deleteArticle(id) {
    await api.delete(`/api/admin/articles/${id}`);
}
export async function changeArticleStatus(id, status) {
    const { data } = await api.patch(`/api/admin/articles/${id}/status`, { status });
    return data.data;
}
export async function getCategories() {
    const { data } = await api.get('/api/admin/categories');
    return data;
}
export async function createCategory(name) {
    const { data } = await api.post('/api/admin/categories', { name });
    return data.data;
}
export async function updateCategory(id, name) {
    await api.patch(`/api/admin/categories/${id}`, { name });
}
export async function deleteCategory(id) {
    await api.delete(`/api/admin/categories/${id}`);
}
